import React, { Component, Fragment } from 'react'
import { Link } from 'react-router-dom'
import Helmet from 'react-helmet'
import { Query, Mutation } from "react-apollo"
import { PositiveComment, NeutralComment, NegativeComment, ProComment, ClientComment, PositiveCommentC, NeutralCommentC, NegativeCommentC } from "../../../queries/comments"
import { RateRankClient, RateRankPro } from '../../../queries/rank'
import Loading from '../../../components/loading/loading'
import dayjs from 'dayjs'
// import Rater from 'react-rater'
// import Star from '../../components/Stars/star'
import CommentCard from "../../../components/commentCard/commentCard";
import AvaliationStar from '../../../components/avaliationStars/avaliationStars'
import Tooltip from '../../../components/tooltip/tooltip'
import Button from '../../../components/newButton/button'
import { Reply } from '../../../queries/comments'
import Input from '../../../components/newInput/input'
// import Tooltip
import ErrorBoundary from '../../../components/errorBoundary/errorBoundary'
import './rankUser.scss'

import negative from '../../../assets/icons/oitonegative.svg'
import neutral from '../../../assets/icons/oitoneutral.svg'
import positive from '../../../assets/icons/oitopositive.svg'

export default class Rank extends Component {

    constructor(props) {
        super(props)
        this.state = {
            skills: [],
            name: '',
            reply: '',
            idComment: ""
        }

        this.setInput = event => {
            this.setState({ reply: event.target.value })
            return event.target.value
        }

        this.openField = id => {
            // console.log(id)
            this.setState({ idComment: id })
            const element = document.getElementById(id)
            if (element.style.display === "none") {
                element.style.display = "block"
            } else {
                element.style.display = "none"
            }
        }

        this.sendReply = Reply => {
            Reply({
                variables: {
                    id: this.state.idComment,
                    reply: this.state.reply
                }
            }).then(
                res => {
                    // console.log(res)
                    if (res.error) {
                        console.log(res.error)
                        return <p>Algo de errado aconteceu. Tente novamente.</p>
                    }
                    this.refetch()
                    document.getElementById(this.state.idComment).style.display = "none"
                    this.setState({ idComment: "", reply: "" })
                    return null
                }
            )
        }
    }

    render() {
        const cache = JSON.parse(sessionStorage.getItem('OITO'))
        if (cache) {
            this.playerId = cache.user.id
            this.name = cache.user.name
            //     skills: cache.user.player.skills,
            // })
        } else {
            window.location.href = '/login'
        }
        return (
            <Fragment>
                <Helmet title='Oito - Desempenho'>
                    <meta name="title" content="Oito.app | Confira o ranking de profissionais qualificados" />
                    <meta name="description" content="Encontre os profissionais mais qualificados e confiáveis por meio do ranking de avaliações positivas da Oito.app." />
                    <meta name="keywords" content="Profissionais, Habilidades, Qualificados" />
                    <meta name="robots" content="index, follow" />
                    <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
                    <meta name="language" content="Portuguese" />
                    <meta name="revisit-after" content="1 days" />
                </Helmet>
                <div className="rankUser col-xs-12" style={{ maxWidth: '980px' }}>
                    <div className="ranking row center-xs">
                        {JSON.parse(sessionStorage.getItem('OITO')) ? null : window.location.href = '/login'}
                        <div className="RankClient col-xs-12 col-sm-6">
                            <h3>Reputação como cliente</h3>

                            <div className="general-review row center-xs">
                            <ErrorBoundary><Query query={PositiveCommentC} variables={{ userId: this.playerId }}>
                                    {res => {
                                        if (res.loading) return <Loading />
                                        if (res.error) return <p>{res.error}</p>
                                        return <div className="col-xs-4">
                                            <img src={positive} alt="positive" />
                                            <div>
                                                <span className={'numbers'}>{res.data.allComments.length}</span>
                                            </div>
                                            <div className={'tooltip'}>Avaliação positiva</div>
                                        </div>
                                    }}
                                </Query></ErrorBoundary>

                                <ErrorBoundary><Query query={NeutralCommentC} variables={{ userId: this.playerId }}>
                                    {res => {
                                        if (res.loading) return <Loading />
                                        if (res.error) return <p>{res.error}</p>
                                        return <div className="col-xs-4">
                                            <div>
                                                <img src={neutral} alt="negative" />
                                            </div>
                                            <div>
                                                <span className={'numbers'}>{res.data.allComments.length}</span>
                                            </div>
                                            <div className={'tooltip'}>Avaliação neutra</div>
                                        </div>
                                    }}
                                </Query></ErrorBoundary>

                                <ErrorBoundary><Query query={NegativeCommentC} variables={{ userId: this.playerId }}>
                                    {res => {
                                        if (res.loading) return <Loading />
                                        if (res.error) return <p>{res.error}</p>
                                        return <div className="col-xs-4">
                                            <div>
                                                <img src={negative} alt="negative" />
                                            </div>
                                            <div>
                                                <span className={'numbers'}>{res.data.allComments.length}</span>
                                            </div>
                                            <div className={'tooltip'}>Avaliação negativa</div>
                                        </div>
                                    }}
                                </Query></ErrorBoundary>
                            </div>
                            <h3><i className="fas fa-chart-line"></i>Desempenho como cliente</h3>
                            <ErrorBoundary><Query query={RateRankClient} variables={{ userId: this.playerId }}>
                                {res => {
                                    if (res.loading) return <Loading />
                                    if (res.error) return <p>{res.error}</p>

                                    if (res.data.allRanks.length) {
                                        let media = []
                                        let custoC = []
                                        let pontualidadeC = []
                                        let respeitoC = []
                                        let transparenciaC = []

                                        res.data.allRanks.map(rank => {
                                            media.push(rank.media)
                                            custoC.push(rank.custoC)
                                            pontualidadeC.push(rank.pontualidadeC)
                                            respeitoC.push(rank.respeitoC)
                                            transparenciaC.push(rank.transparenciaC)
                                            return null
                                        })

                                        const clientRate = parseInt(media.reduce((sum, num) => sum + num) / media.length)
                                        const custoCRate = parseInt(custoC.reduce((sum, num) => sum + num) / custoC.length)
                                        const pontualidadeCRate = parseInt(pontualidadeC.reduce((sum, num) => sum + num) / pontualidadeC.length)
                                        const respeitoCRate = parseInt(respeitoC.reduce((sum, num) => sum + num) / respeitoC.length)
                                        const transparenciaCRate = parseInt(transparenciaC.reduce((sum, num) => sum + num) / transparenciaC.length)

                                        return <div className="row">
                                            <div className="performance-card col-xs-12">
                                                <div className="row middle-xs between-xs" style={{ marginTop: "15px", borderBottom: "1px solid #dadada" }}>
                                                    <div className="col-xs-6 col-sm-7 col-md-8">
                                                    <div className="row">
                                                        <span style={{ fontWeight: 'bold', marginRight: '5px' }}>Média</span>
                                                        <Tooltip text={`Média geral. Total de avaliadores: ${res.data.allRanks.length}`} />
                                                        </div>
                                                    </div>
                                                    <div className="col-xs-6 col-sm-5 col-md-4">
                                                    <div className="row end-xs">
                                                      <AvaliationStar avaliation={clientRate} /></div></div>
                                                </div>
                                            </div>
                                            <div className="performance-card col-xs-12">
                                                <div className="row middle-xs between-xs" style={{ marginTop: "15px", borderBottom: "1px solid #dadada" }}>
                                                    <div className="col-xs-6 col-sm-7 col-md-8">
                                                      <div className="row">
                                                        <span style={{ fontWeight: 'bold', marginRight: '5px' }}>Custo-benefício</span>
                                                        <Tooltip text={'O valor pago é justo em relação ao serviço prestado?'} />
                                                      </div>
                                                    </div>
                                                    <div className="col-xs-6 col-sm-5 col-md-4">
                                                    <div className="row end-xs">
                                                      <AvaliationStar avaliation={custoCRate} /></div></div>
                                                </div>
                                            </div>
                                            <div className="performance-card col-xs-12">
                                                <div className="row middle-xs between-xs" style={{ marginTop: "15px", borderBottom: "1px solid #dadada" }}>
                                                    <div className="col-xs-6 col-sm-7 col-md-8">
                                                    <div className="row">
                                                        <span style={{ fontWeight: 'bold', marginRight: '5px' }}>Pontualidade no pagamento</span>
                                                        <Tooltip text={'O cliente que contratou seu serviço pagou de forma pontual?'} />
                                                        </div>
                                                    </div>
                                                    <div className="col-xs-6 col-sm-5 col-md-4">
                                                    <div className="row end-xs">
                                                      <AvaliationStar avaliation={pontualidadeCRate} /></div></div>
                                                </div>
                                            </div>
                                            <div className="performance-card col-xs-12">
                                                <div className="row middle-xs between-xs" style={{ marginTop: "15px", borderBottom: "1px solid #dadada"  }}>
                                                    <div className="col-xs-6 col-sm-7 col-md-8">
                                                    <div className="row">
                                                        <span style={{ fontWeight: 'bold', marginRight: '5px' }}>Respeito no atendimento</span>
                                                        <Tooltip text={'O cliente que contratou você foi respeitoso e atencioso durante sua prestação de serviço?'} />
                                                        </div>
                                                    </div>
                                                    <div className="col-xs-6 col-sm-5 col-md-4">
                                                      <div className="row end-xs">
                                                        <AvaliationStar avaliation={respeitoCRate} />
                                                      </div>
                                                      </div>
                                                </div>
                                            </div>
                                            <div className="performance-card col-xs-12">
                                                <div className="row middle-xs between-xs" style={{ marginTop: "15px", borderBottom: "1px solid #dadada"  }}>
                                                    <div className="col-xs-6 col-sm-7 col-md-8">
                                                    <div className="row">
                                                        <span style={{ fontWeight: 'bold', marginRight: '5px' }}>Transparência no serviço</span>
                                                        <Tooltip text={'A descrição do serviço estava coerente com o que fora executado?'} />
                                                        </div>
                                                    </div>
                                                    <div className="col-xs-6 col-sm-5 col-md-4">
                                                    <div className="row end-xs">
                                                      <AvaliationStar avaliation={transparenciaCRate} /></div></div>
                                                </div>
                                            </div>
                                        </div>
                                    } else {
                                        return <div id="empty-client"><p>Você não possui avaliação como Cliente. <br /><Link to="/anuncios">Contrate alguém</Link> e facilite sua vida!</p></div>
                                    }
                                }}
                            </Query></ErrorBoundary>
                        </div>
                        <div className="RankProfissional col-xs-12 col-sm-6">
                            <h3>Reputação como profissional</h3>

                            <div className="general-review row center-xs">
                            <ErrorBoundary><Query query={PositiveComment} variables={{ userId: this.playerId }}>
                                    {res => {
                                        if (res.loading) return <Loading />
                                        if (res.error) return <p>{res.error}</p>
                                        return <div className="col-xs-4">
                                            <img src={positive} alt="positive" />
                                            <div>
                                                <span className={'numbers'}>{res.data.allComments.length}</span>
                                            </div>
                                            <div className={'tooltip'}>Avaliação positiva</div>
                                        </div>
                                    }}
                                </Query></ErrorBoundary>

                                <ErrorBoundary><Query query={NeutralComment} variables={{ userId: this.playerId }}>
                                    {res => {
                                        if (res.loading) return <Loading />
                                        if (res.error) return <p>{res.error}</p>
                                        return <div className="col-xs-4">
                                            <img src={neutral} alt="neutral" />
                                            <div>
                                                <span className={'numbers'}>{res.data.allComments.length}</span>
                                            </div>
                                            <div className={'tooltip'}>Avaliação neutra</div>
                                        </div>
                                    }}
                                </Query></ErrorBoundary>

                                <ErrorBoundary><Query query={NegativeComment} variables={{ userId: this.playerId }}>
                                    {res => {
                                        if (res.loading) return <Loading />
                                        if (res.error) return <p>{res.error}</p>
                                        return <div className="col-xs-4">
                                            <img src={negative} alt="negative" />
                                            <div style={{ flex: '0 0 100%' }}>
                                                <span className={'numbers'}>{res.data.allComments.length}</span>
                                            </div>
                                            <div className={'tooltip'}>Avaliação negativa </div>
                                        </div>
                                    }}
                                </Query></ErrorBoundary>
                            </div>

                            <h3><i className="fas fa-chart-line"></i>Desempenho como Profissional</h3>

                            <ErrorBoundary><Query query={RateRankPro} variables={{ userId: this.playerId }}>
                                {res => {
                                    if (res.loading) return <Loading />
                                    if (res.error) return <p>{res.error}</p>
                                    // console.log("profissional", res.data.allRanks)
                                    if (res.data.allRanks.length) {
                                        let media = []
                                        let agilidade = []
                                        let atendimento = []
                                        let custo = []
                                        let ferramentas = []
                                        let pontualidade = []
                                        let resposta = []
                                        let solucao = []

                                        res.data.allRanks.map(rank => {
                                            media.push(rank.media)
                                            agilidade.push(rank.agilidade)
                                            atendimento.push(rank.atendimento)
                                            custo.push(rank.custo)
                                            ferramentas.push(rank.ferramentas)
                                            pontualidade.push(rank.pontualidade)
                                            resposta.push(rank.resposta)
                                            solucao.push(rank.solucao)
                                            return null
                                        })

                                        const proRate = parseInt(media.reduce((sum, num) => sum + num) / media.length)
                                        const agilidadeRate = parseInt(agilidade.reduce((sum, num) => sum + num) / agilidade.length)
                                        const atendimentoRate = parseInt(atendimento.reduce((sum, num) => sum + num) / atendimento.length)
                                        const custoRate = parseInt(custo.reduce((sum, num) => sum + num) / custo.length)
                                        const ferramentasRate = parseInt(ferramentas.reduce((sum, num) => sum + num) / ferramentas.length)
                                        const pontualidadeRate = parseInt(pontualidade.reduce((sum, num) => sum + num) / pontualidade.length)
                                        const respostaRate = parseInt(resposta.reduce((sum, num) => sum + num) / resposta.length)
                                        const solucaoRate = parseInt(solucao.reduce((sum, num) => sum + num) / solucao.length)

                                        return <div className="row">
                                            <div className="performance-card col-xs-12">
                                                <div className="row middle-xs between-xs" style={{ marginTop: "15px", borderBottom: "1px solid #dadada" }}>
                                                    <div className="col-xs-6 col-sm-7 col-md-8">
                                                    <div className="row">
                                                        <span style={{ fontWeight: 'bold', marginRight: '5px' }}>Média</span>
                                                        <Tooltip text={`Média geral. Total de avaliadores: ${res.data.allRanks.length}`} />
                                                    </div>
                                                    </div>
                                                    <div className="col-xs-6 col-sm-5 col-md-4">
                                                    <div className="row end-xs"><AvaliationStar avaliation={proRate} /></div></div>
                                                </div>
                                            </div>
                                            <div className="performance-card col-xs-12">
                                                <div className="row middle-xs between-xs" style={{ marginTop: "15px", borderBottom: "1px solid #dadada" }}>
                                                    <div className="col-xs-6 col-sm-7 col-md-8">
                                                    <div className="row">
                                                        <span style={{ fontWeight: 'bold', marginRight: '5px' }}>Agilidade no serviço</span>
                                                        <Tooltip text={`O serviço foi feito de forma ágil e eficiente?`} />
                                                    </div>
                                                    </div>
                                                    <div className="col-xs-6 col-sm-5 col-md-4">
                                                    <div className="row end-xs"><AvaliationStar avaliation={agilidadeRate} /></div></div>
                                                </div>
                                            </div>
                                            <div className="performance-card col-xs-12">
                                                <div className="row middle-xs between-xs" style={{ marginTop: "15px", borderBottom: "1px solid #dadada" }}>
                                                    <div className="col-xs-6 col-sm-7 col-md-8">
                                                    <div className="row">
                                                        <span style={{ fontWeight: 'bold', marginRight: '5px' }}>Atendimento</span>
                                                        <Tooltip text={`O prestador de serviço atendeu você com respeito, dedicação e transparência?`} />
                                                    </div>
                                                    </div>
                                                    <div className="col-xs-6 col-sm-5 col-md-4">
                                                    <div className="row end-xs"><AvaliationStar avaliation={atendimentoRate} /></div></div>
                                                </div>
                                            </div>
                                            <div className="performance-card col-xs-12">
                                                <div className="row middle-xs between-xs" style={{ marginTop: "15px", borderBottom: "1px solid #dadada" }}>
                                                    <div className="col-xs-6 col-sm-7 col-md-8">
                                                    <div className="row">
                                                        <span style={{ fontWeight: 'bold', marginRight: '5px' }}>Custo-benefício</span>
                                                        <Tooltip text={`Como você avalia a relação de valores e entrega do serviço?`} />
                                                    </div>
                                                    </div>
                                                    <div className="col-xs-6 col-sm-5 col-md-4">
                                                    <div className="row end-xs"><AvaliationStar avaliation={custoRate} /></div></div>
                                                </div>
                                            </div>
                                            <div className="performance-card col-xs-12">
                                                <div className="row middle-xs between-xs" style={{ marginTop: "15px", borderBottom: "1px solid #dadada" }}>
                                                    <div className="col-xs-6 col-sm-7 col-md-8">
                                                    <div className="row">
                                                        <span style={{ fontWeight: 'bold', marginRight: '5px' }}>Ferramentas necessárias</span>
                                                        <Tooltip text={`O prestador de serviço levou todas as ferramentas necessárias para a execução do serviço?`} />
                                                    </div>
                                                    </div>
                                                    <div className="col-xs-6 col-sm-5 col-md-4">
                                                    <div className="row end-xs"><AvaliationStar avaliation={ferramentasRate} /></div></div>
                                                </div>
                                            </div>
                                            <div className="performance-card col-xs-12">
                                                <div className="row middle-xs between-xs" style={{ marginTop: "15px", borderBottom: "1px solid #dadada" }}>
                                                    <div className="col-xs-6 col-sm-7 col-md-8">
                                                    <div className="row">
                                                        <span style={{ fontWeight: 'bold', marginRight: '5px' }}>Pontualidade</span>
                                                        <Tooltip text={`Todos os prazos combinados durante a negociação e execução dos serviços foram cumpridos sem atrasos?`} />
                                                    </div>
                                                    </div>
                                                    <div className="col-xs-6 col-sm-5 col-md-4">
                                                    <div className="row end-xs"><AvaliationStar avaliation={pontualidadeRate} /></div></div>
                                                </div>
                                            </div>
                                            <div className="performance-card col-xs-12">
                                                <div className="row middle-xs between-xs" style={{ marginTop: "15px", borderBottom: "1px solid #dadada" }}>
                                                    <div className="col-xs-6 col-sm-7 col-md-8">
                                                    <div className="row">
                                                        <span style={{ fontWeight: 'bold', marginRight: '5px' }}>Respostas no chat</span>
                                                        <Tooltip text={`O prestador de serviço usou o chat de forma ágil, respeitosa e clara?`} />
                                                    </div>
                                                    </div>
                                                    <div className="col-xs-6 col-sm-5 col-md-4">
                                                    <div className="row end-xs"><AvaliationStar avaliation={respostaRate} /></div></div>
                                                </div>
                                            </div>
                                            <div className="performance-card col-xs-12">
                                                <div className="row middle-xs between-xs" style={{ marginTop: "15px", borderBottom: "1px solid #dadada" }}>
                                                    <div className="col-xs-6 col-sm-7 col-md-8">
                                                    <div className="row">
                                                        <span style={{ fontWeight: 'bold', marginRight: '5px' }}>Solução do problema</span>
                                                        <Tooltip text={`O prestador de serviço contratado solucionou seu problema de forma eficiente?`} />
                                                        </div>
                                                        </div>
                                                    <div className="col-xs-6 col-sm-5 col-md-4">
                                                    <div className="row end-xs"><AvaliationStar avaliation={solucaoRate} /></div></div>
                                                </div>
                                            </div>
                                        </div>
                                    } else {
                                        return <div id="empty-client"><p>Você não possui avaliação como Profissional.<br /> <Link to="/perfil/data">Anuncie seus serviços</Link> e faça dinheiro extra.</p></div>
                                    }
                                }}
                            </Query></ErrorBoundary>
                        </div>
                    </div>
                    
                </div>
                <div className="commentsR col-xs-12" style={{ maxWidth: '980px', marginTop: "30px" }}>
                  <div className="row center-xs">
                    <div className="col-xs-12 col-sm-6">
                            <h3>Comentários como Cliente</h3>

                            <ErrorBoundary><Query query={ClientComment} fetchPolicy="no-cache" variables={{ userId: this.playerId }}>
                                {res => {
                                    // console.log(res.data.allComments)
                                    if (res.loading) return <Loading />
                                    if (res.error) return <p>{res.error}</p>
                                    // return console.log(res.data)
                                    this.refetch = res.refetch;
                                    if (res.data.allComments.length) {
                                        const comments = res.data.allComments

                                        return comments.map((comment, i) => (
                                            <div key={i} className="row">
                                                <CommentCard comment={comment} />
                                                {(!comment.reply && dayjs(comment.date).add(15, 'day').isAfter(dayjs(Date.now()))) ? <div onClick={() => this.openField(comment.id)}>
                                                    + Adicionar uma Replica</div> : null}

                                                <div id={comment.id} style={{ display: "none", textAlign: "center" }}>
                                                    <Input name="replyC" placeholder="Digite aqui sua réplica." type="text" defaultValue={this.state.reply} onInput={this.setInput} maxLength={140} required={true} />
                                                    <Mutation mutation={Reply}>
                                                        {(Reply, { loading, error }) => {
                                                            if (loading) return <Loading />
                                                            if (error) return console.log(Reply.error)
                                                            return <Button
                                                                name='Enviar réplica'
                                                                type='submit'
                                                                disabled={this.state.reply ? false : true}
                                                                onClick={() => this.sendReply(Reply)}
                                                            />
                                                        }}
                                                    </Mutation>
                                                </div>
                                            </div>
                                        ))
                                    } else {
                                        return <div><div id="empty-client"><p>Você não possui comentarios como Cliente.<br /> <Link to="/anuncios">Contrate alguém</Link> facilite sua vida!</p></div></div>
                                    }
                                }}
                            </Query></ErrorBoundary>
                        </div>
                        <div className="col-xs-12 col-sm-6">
                        
                            <h3>Comentários como Profissional</h3>

                            <div className="card-list">
                            <ErrorBoundary><Query query={ProComment} fetchPolicy="no-cache" variables={{ userId: this.playerId }}>
                                    {res => {
                                        // console.log(res.data.allComments)
                                        if (res.loading) return <Loading />
                                        if (res.error) return <p>{res.error}</p>
                                        // return console.log(res.data)
                                        this.refetch = res.refetch
                                        if (res.data.allComments.length) {
                                            const comments = res.data.allComments

                                            return comments.map((comment, i) => (
                                                <>
                                                    <CommentCard key={i} comment={comment} />
                                                    {(!comment.reply && dayjs(comment.date).add(15, 'day').isAfter(dayjs(Date.now()))) ? <div onClick={() => this.openField(comment.id)}>
                                                        + Adicionar uma Replica</div> : null}

                                                    <div id={comment.id} style={{ display: "none", textAlign: "center" }}>
                                                        <Input name="replyP" placeholder="Digite aqui sua réplica." type="text" defaultValue={this.state.reply} onInput={this.setInput} maxLength={140} required={true} />
                                                        <Mutation mutation={Reply}>
                                                            {(Reply, { loading, error }) => {
                                                                if (loading) return <Loading />
                                                                if (error) return console.log(Reply.error)
                                                                return <Button
                                                                    name='Enviar réplica'
                                                                    type='submit'
                                                                    disabled={this.state.reply ? false : true}
                                                                    onClick={() => this.sendReply(Reply)}
                                                                />
                                                            }}
                                                        </Mutation>
                                                    </div>
                                                </>
                                            ))
                                        } else {
                                            return <div id="empty-client"><p>Você não possui comentários como Profissional.<br /> <Link to="/perfil/data">Anuncie seus serviços</Link> e faça um dinheiro extra.</p></div>
                                        }
                                    }}
                                </Query></ErrorBoundary>
                            </div>
                        </div>
                    </div>
                    </div>
            </Fragment>
        )
    }
}
